<template>
  <div v-if="label" class="strapi-label">
    <div
      class="strapi-label-title"
      :class="{ opened: opened }"
      @click="opened = !opened"
    >
      {{ label.title }}
      <icons-icon-chevron-down v-show="!!label.description" />
    </div>
    <div v-show="label.description && opened" class="strapi-label-desc">
      {{ label.description }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiLabel } from "~/types/strapi";

const props = defineProps<{
  label?: StrapiLabel | undefined;
}>();

const opened = ref<boolean>(!!props.label?.openedByDefault);
</script>

<style lang="scss">
.strapi-label {
  &-title {
    @apply inline-flex cursor-pointer select-none items-center gap-1 text-lg font-semibold;

    svg {
      @apply mx-2 text-zinc-500 transition-all hover:bg-neutral-100;
    }

    &.opened {
      svg {
        @apply rotate-180;
      }
    }
  }

  &-desc {
    @apply pt-2 text-zinc-500;
  }
}
</style>
